import { CONTACT_TYPES_URL } from 'core/constants';
import { createApiRequest } from 'core/util';
import type { AppThunk, AppDispatch } from 'core/store';
import { fetchContactTypesSuccess } from 'features/shared/contacts/ContactTypesSlice';

/** Raw shape of one `GET /home/contact_types` result item, per the API contract. */
interface RawContactType {
  id: number;
  field: string;
  label: string;
}

// id 102 is a duplicate "Applicate_Repair_Person" entry. Hidden from the UI without
// touching the catalog itself; existing contacts of this type remain valid, they
// just can't be selected in the add-contact modal.
const HIDDEN_CONTACT_TYPE_IDS = [102];

export const normalizeContactTypes = (rawItems: RawContactType[]) =>
  fetchContactTypesSuccess(
    rawItems
      .filter((item) => !HIDDEN_CONTACT_TYPE_IDS.includes(item.id))
      .map((item) => ({ name: item.label, type: item.field }))
  );

export const fetchContactTypes = (): AppThunk => (dispatch: AppDispatch) => {
  // Global, non-home-scoped reference data. Always refetched on mount
  // (rather than gated on a "loaded" flag) since the persisted Redux store
  // (redux-persist) would otherwise cache a stale catalog indefinitely
  // across app relaunches once fetched a single time.
  dispatch(
    createApiRequest({
      route: CONTACT_TYPES_URL,
      onSuccess: normalizeContactTypes,
      defaultErrorMessage: 'There was a problem loading contact types.'
    })()
  );
};
